import EventActionProto from '../event-action-proto'
import {SESSION_PROJECT_USERS_CHANGED} from "../../gd/bus/bus-event-type"
import Session_reinitNavigationStructure from "../functions/reinit-navigation-structure"

/*
prisilaem mnogo project users
ob ih grupiruet i reset project users by project
 */


export default class EventProjectUsersResetByProjectRecursive extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {

        if (this.data) {
            const groupedByProject = _.groupBy(this.data, 'projectId');

            _.map(groupedByProject, (projectUsers, projectId)=>{
                gd.session.projectUsers.resetAndKeepOldModels(this.data, {projectId: projectId, silent: true})
            })

            Session_reinitNavigationStructure()

            gd.session.projectUsers.trigger("reset");
            gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)
        }
    }


};
